import { useMemo } from "react";
import { Cell, Pie, PieChart } from "recharts";

import { RechartPieChartData } from "@helpers/charts";
import { pluralize } from "@helpers/string";

const EngagementSurveyQuestionPieChart = ({
  data,
  sorted,
}: {
  data: RechartPieChartData[];
  sorted?: boolean;
}) => {
  const sortedData = useMemo(
    () => (sorted ? data.sort((a, b) => b.value - a.value) : data),
    [data, sorted],
  );
  const total = useMemo(
    () => sortedData.reduce((sum, entry) => sum + entry.value, 0),
    [sortedData],
  );
  return (
    <div className="bg-gray-50 rounded-md p-6 flex items-center justify-center gap-12">
      <div>
        <PieChart width={100} height={100}>
          <Pie
            data={sortedData}
            startAngle={90}
            endAngle={-270}
            cx="50%"
            cy="50%"
            innerRadius={30}
            outerRadius={50}
            dataKey="value"
          >
            <>
              {sortedData.map((entry) => (
                <Cell key={`cell-${entry.name}`} fill={entry.color} />
              ))}
            </>
          </Pie>
        </PieChart>
      </div>

      <table>
        <tbody>
          {sortedData.map((entry) => (
            <tr key={entry.name}>
              <td className="py-1 px-1">
                <div
                  className="rounded h-3 w-3"
                  style={{ backgroundColor: entry.color }}
                ></div>
              </td>
              <td className="py-1 px-1 font-semibold">
                {Math.round((entry.value / total) * 100) + "%"}
              </td>
              <td className="py-1 px-3">{entry.name}</td>
              <td className="py-1 px-3 text-sm text-gray-500">{`${
                entry.value
              } ${pluralize("response", entry.value)}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EngagementSurveyQuestionPieChart;
